/**
 * ===================================================================
 * RAV FEATURE FLAGS
 * ===================================================================
 * Este arquivo centraliza todas as feature flags relacionadas ao
 * Recebimento Automático de Vendas (RAV).
 *
 * Para manter a clareza, as flags são separadas em ativas e
 * depreciadas.
 * ===================================================================
 */

export const activeRavFlags = [
  'cet_enabled_web',
  'cet_enabled',
  'prepay_home_web_v0',
  'new_home_web',
  'new_prepay_automatic_selection_web',
  'prepayment_onestone_web',
  'prepayment_spot_short_flow'
] as const
